import React, {Suspense} from "react";
import {Switch} from "react-router-dom";
import {LayoutSplashScreen, ContentRoute} from "../../../_metronic/layout";
import {AutomatedPaymentsPage as PaymentsPage} from './pages/AutomatedPaymentsPage';

export default function AutomatedPaymentsPage() {
    return (
        <Suspense fallback={<LayoutSplashScreen />}>
            <Switch>
                <ContentRoute path="/automated-payments" component={PaymentsPage} />
            </Switch>
        </Suspense>
    );
}
